import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ramadan20-fortnite',
  templateUrl: './ramadan20-fortnite.component.html',
  styleUrls: ['./ramadan20-fortnite.component.css']
})
export class Ramadan20FortniteComponent implements OnInit {

  gameName = "fortnite"
  constructor() { }

  ngOnInit() {
  }

}
